import terms, { isRussianLocale } from 'i18n';

const useLazyIdEnumSelectProps = (useGetEnumQuery: Function) => {
  const { data, isLoading, isError } = useGetEnumQuery();

  return {
    options: data
      ? data.map?.(el => ({
          id: el.id,
          value: el.id,
          label: isRussianLocale() ? el.title : el.titleForeign,
        }))
      : [],
    isLoading,
    error: isError && !data ? terms.LOADING_ERROR : undefined,
  };
};

export default useLazyIdEnumSelectProps;
